function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { MainStyles } from 'resources/styles/MainStyles';
import { Platform } from 'react-native';
import { Stack, SizableText, XStack, YStack, useTheme, styled } from 'tamagui';
import { Flex } from 'components/base/General';
import { wrapImgCDN, formatTextDate } from 'utils/misc';
import { Link } from 'solito/link';
import { Bookmark } from 'components/utility/Buttons';
import Image from 'components/utility/CrossPlatformImage';
import { useSelector, useDispatch } from 'react-redux';
import { StackPaperIcon } from 'components/utility/SVGIcons';
import { useCreateOrUpdateBookmarkMutation, useDeleteBookmarkMutation } from 'utils/RTKGraphQL';
import { toggleLogin } from 'reducers/slices/loginstatus';
export const WhiteOuterCard = styled(YStack, {
  name: 'WhiteOuterCard',
  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px',
  elevation: 0.5,
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 1
  },
  shadowOpacity: 0.8,
  shadowRadius: 1
});
const CardBookmark = props => {
  return /*#__PURE__*/React.createElement(Flex, {
    zIndex: 999,
    height: 'auto',
    position: "absolute",
    right: 4.5,
    top: -0.5
  }, /*#__PURE__*/React.createElement(Stack, {
    bg: "$pred400",
    height: 32,
    width: 32,
    justifyContent: "center",
    alignItems: "center",
    borderBottomLeftRadius: 8
  }, /*#__PURE__*/React.createElement(Bookmark, {
    saved: props.bookmark,
    onPress: props.bookmarkPress,
    article: props.article,
    size: 18
  })));
};
const CardStack = () => {
  return /*#__PURE__*/React.createElement(Flex, {
    zIndex: 999,
    height: 'auto',
    position: "absolute",
    bottom: 0,
    left: 4.5
  }, /*#__PURE__*/React.createElement(Stack, {
    bg: "$pred400",
    height: 32,
    width: 32,
    justifyContent: "center",
    alignItems: "center",
    borderTopRightRadius: 15
  }, /*#__PURE__*/React.createElement(Stack, {
    position: "absolute",
    bottom: 0,
    top: 3,
    left: 3,
    right: 0
  }, /*#__PURE__*/React.createElement(StackPaperIcon, {
    color: "white"
  }))));
};
const HSKLevel = ({
  hskLevel
}) => {
  const hskStyle = 'HSK' + hskLevel;
  return /*#__PURE__*/React.createElement(Stack, {
    display: "flex",
    style: [MainStyles.articleHSK, MainStyles[hskStyle]],
    marginLeft: -0.5
  }, /*#__PURE__*/React.createElement(SizableText, {
    fontSize: "$lg",
    color: "white",
    fontWeight: "bold",
    style: [MainStyles.articleHSKText, {
      userSelect: Platform.OS === 'web' ? 'none' : null
    }]
  }, "HSK ", hskLevel));
};
const Premium = props => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(SizableText, {
    fontWeight: "bold",
    fontSize: "$xs",
    zIndex: 500,
    color: theme.premiumColor
  }, props.text));
};
const CardSubText = props => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(SizableText, {
    color: props.color ? props.color : theme.subtext,
    fontSize: "$xs",
    textAlign: "left"
  }, props.children);
};
const CardText = props => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(SizableText, {
    color: theme.mainColor.get(),
    fontSize: "$sm",
    fontWeight: "bold",
    textAlign: "left"
  }, props.children);
};
const WhiteCard = props => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(WhiteOuterCard, {
    bg: theme.cardBG,
    pt: 12,
    px: 8,
    mb: 20,
    width: 275,
    height: 300,
    borderRadius: 15,
    alignItems: "center"
    //pointerEvents="none"
    //hoverStyle={0.5}
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    alignSelf: "center",
    mx: 10,
    style: {
      cursor: 'pointer'
    },
    width: "100%"
  }, /*#__PURE__*/React.createElement(HSKLevel, {
    hskLevel: props.article.collectionPerLanguage[0].displaySkill.level
  }), /*#__PURE__*/React.createElement(Image, {
    borderRadius: 15,
    width: 250,
    height: 160,
    resizeMode: "cover",
    source: {
      uri: props.cdnURL
    },
    alt: props.article.title
  }), props.article.articleCount > 1 ? /*#__PURE__*/React.createElement(CardStack, null) : /*#__PURE__*/React.createElement(CardBookmark, {
    bookmark: props.bookmark,
    article: props.article,
    bookmarkPress: props._bookmarkToggle
  })), /*#__PURE__*/React.createElement(YStack, {
    mt: 8,
    justifyContent: "space-between",
    display: "flex",
    flexGrow: 1,
    width: 250
  }, /*#__PURE__*/React.createElement(CardText, null, props.article.title), /*#__PURE__*/React.createElement(XStack, {
    justifyContent: "space-between",
    mb: 4
  }, /*#__PURE__*/React.createElement(CardSubText, {
    color: theme.mainColor.get()
  }, formatTextDate(props.article.date)), /*#__PURE__*/React.createElement(Stack, null, props.article.collectionPerLanguage[0].premium ? /*#__PURE__*/React.createElement(Premium, {
    text: props.article.collectionPerLanguage[0].premium > 1 ? 'Premium' : 'Login'
  }) : null))));
};
const Card = props => {
  const [bookmark, setBookmark] = useState(props.article.bookmarked);
  const cdnURL = wrapImgCDN(props.article.image, 400);
  const profile = useSelector(state => state.profile);
  const dispatch = useDispatch();
  const [createOrUpdateBookmark] = useCreateOrUpdateBookmarkMutation();
  const [deleteBookmark] = useDeleteBookmarkMutation();
  const _bookmarkToggle = async () => {
    if (!profile) {
      dispatch(toggleLogin(true));
      return;
    }
    if (bookmark) {
      await deleteBookmark({
        userId: profile.id,
        collectionId: props.article.id
      });
    } else {
      await createOrUpdateBookmark({
        userId: profile.id,
        collectionId: props.article.id
      });
    }
    setBookmark(!bookmark);
  };
  const cardPath = props.article.articleCount > 1 ? `/collection/${props.article.slug}` : `/article/${props.article.articleSlug}`;
  return /*#__PURE__*/React.createElement(Link, {
    href: cardPath,
    pointerEvents: "none"
  }, /*#__PURE__*/React.createElement(Stack, {
    disabled: true,
    display: "flex",
    alignItems: "center",
    width: 250,
    zIndex: 150,
    borderRadius: 15,
    hoverStyle: {
      opacity: 0.6
    },
    pressStyle: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement(WhiteCard, _extends({}, props, {
    _bookmarkToggle: _bookmarkToggle,
    cdnURL: cdnURL,
    bookmark: bookmark
  }))));
};
export default Card;